import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import PlanilhaCssbuyPage from "../pages/planilha-cssbuy/page";
import CssbuyYupooPage from "../pages/cssbuy-yupoo/page";
import CssbuyReviewPage from "../pages/cssbuy-review/page";
import ComoUsarCssbuyPage from "../pages/como-usar-cssbuy/page";
import CssbuyVsPandabuyPage from "../pages/cssbuy-vs-pandabuy/page";
import MelhoresLinksPage from "../pages/melhores-links/page";
import GuiaEnvioPage from "../pages/guia-envio/page";
import ComprasSegurasPage from "../pages/compras-seguras/page";
import CssbuySpreadsheetPage from "../pages/cssbuy-spreadsheet/page";
import GuiaDeComprasPage from "../pages/guia-de-compras/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-guia-completo",
    element: <ArticlePage />,
  },
  {
    path: "/planilha-cssbuy",
    element: <PlanilhaCssbuyPage />,
  },
  {
    path: "/cssbuy-yupoo",
    element: <CssbuyYupooPage />,
  },
  {
    path: "/cssbuy-review",
    element: <CssbuyReviewPage />,
  },
  {
    path: "/como-usar-cssbuy",
    element: <ComoUsarCssbuyPage />,
  },
  {
    path: "/cssbuy-vs-pandabuy",
    element: <CssbuyVsPandabuyPage />,
  },
  {
    path: "/melhores-links",
    element: <MelhoresLinksPage />,
  },
  {
    path: "/guia-envio",
    element: <GuiaEnvioPage />,
  },
  {
    path: "/compras-seguras",
    element: <ComprasSegurasPage />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CssbuySpreadsheetPage />,
  },
  {
    path: "/guia-de-compras",
    element: <GuiaDeComprasPage />,
  },
  {
    path: "/politica-editorial",
    element: <PlaceholderPage title="Política Editorial" description="Conheça nossa política editorial: como selecionamos, verificamos e atualizamos os links e informações do CSSBuy Spreadsheet para garantir a melhor experiência." path="/politica-editorial" />,
  },
  {
    path: "/disclaimer",
    element: <PlaceholderPage title="Disclaimer" description="Aviso legal sobre o uso do CSSBuy Spreadsheet. Informações importantes sobre responsabilidade, links de afiliados e termos de uso do nosso conteúdo." path="/disclaimer" />,
  },
  {
    path: "/contato",
    element: <PlaceholderPage title="Contato" description="Entre em contato com a equipe do CSSBuy Spreadsheet Brasil. Tire dúvidas, reporte problemas ou sugira novos links e vendedores para nossa planilha." path="/contato" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

function PlaceholderPage({ title, description, path }: { title: string; description: string; path: string }) {
  const SITE_URL = import.meta.env.VITE_SITE_URL || "https://cssbuy.biz";
  const pageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": `${SITE_URL}${path}`,
    "inLanguage": "pt-BR",
    "isPartOf": {
      "@type": "WebSite",
      "name": "CSSBuy Spreadsheet Brasil",
      "url": SITE_URL,
    },
  };
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Início", "item": `${SITE_URL}/` },
      { "@type": "ListItem", "position": 2, "name": title, "item": `${SITE_URL}${path}` },
    ],
  };
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-background-50">
        <h1 className="font-heading text-3xl font-bold text-foreground-900 mb-4">{title}</h1>
        <p className="text-foreground-500 mb-6">{description}</p>
        <a
          href="/"
          className="px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
        >
          Voltar ao Início
        </a>
      </div>
    </>
  );
}

export default routes;